import type { DriveStep } from 'driver.js';

export const staffDashboardTourId = 'staff:dashboard';

export const staffDashboardSteps: DriveStep[] = [
  {
    element: '[data-tour="staff:sidebar"]',
    popover: {
      title: 'Навигация',
      description:
        'Это боковая панель навигации. Отсюда вы можете перейти в любой раздел: заказы, приёмка, инвентаризация, сканер.',
    },
  },
  {
    element: '[data-tour="staff:stats-cards"]',
    popover: {
      title: 'Статистика',
      description:
        'Здесь отображается сводка по вашему пункту выдачи: сколько заказов ожидает приёмки, сколько готово к выдаче, есть ли недостачи.',
    },
  },
  {
    element: '[data-tour="staff:recent-orders"]',
    popover: {
      title: 'Последние заказы',
      description:
        'Список последних заказов. Кликните на заказ, чтобы увидеть детали и изменить статус.',
    },
  },
  {
    element: '[data-tour="staff:quick-actions"]',
    popover: {
      title: 'Быстрые действия',
      description:
        'Быстрые действия: загрузить поставку, перейти к заказам или начать инвентаризацию — всё в один клик.',
    },
  },
  {
    element: '[data-tour="staff:notifications-bell"]',
    popover: {
      title: 'Уведомления',
      description:
        'Колокольчик уведомлений. Здесь будут отображаться важные события.',
    },
  },
  {
    element: '[data-tour="staff:help-btn"]',
    popover: {
      title: 'Помощь',
      description:
        'Нажмите эту кнопку в любой момент, чтобы запустить обучение заново.',
    },
  },
];
